import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useRecoilState, useSetRecoilState } from "recoil";
import {
  PaymentModalState,
  alertModalState,
  cashBillModalState, paymentDoneModalState, cardSignModalState,
} from "../../utils/atom";
import ModalWrapper from "./ModalWrapper";
import Button from "../elements/Button";
import {api} from "../../utils/api";
import Input from "../elements/Input";
import useSWR from "swr";
import { ReactComponent as Minus } from "../../assets/icons/minus-icon.svg";
import { ReactComponent as NonSearch } from "../../assets/icons/non-search-icon.svg";
import moment from "moment";

const PaymentModal = () => {
  const [page, setPage] = useState(1);
  const [carNumber, setCarNumber] = useState('');
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');

  const [reservationId, setReservationId] = useState('');

  const [modal, setModal] = useRecoilState(PaymentModalState);
  const setCashBillModal = useSetRecoilState(cashBillModalState);
  const setDoneModal = useSetRecoilState(paymentDoneModalState);
  const setSignModal = useSetRecoilState(cardSignModalState);

  const { data: reservationData } = useSWR(page === 2 ? `/order/find/reservation?car_number=${carNumber}&name=${name}&phone=${phone}` : "");
  const originalReservationData = reservationData?.detailing_reservations

  const handlePage = () => {
    if (page === 1) {
      if (carNumber === "") {
        window.alert("차량번호를 입력해주세요");
        return false
      }
      setPage(2)

    } else if (page === 2) { {
      handlePayment()
    }}
  };

  const handleClose = () => {
    setName("");
    setPhone("");
    setCarNumber("");
    setPage(1)
    setModal(null);
  };

  const handlePayment = async () => {
    const formData = new FormData();
    // @ts-ignore
    formData.append("discount_price", modal?.discount?.toString());
    // @ts-ignore
    JSON.parse(localStorage.getItem("order"))?.map((menu, i) => {
        formData.append(`pos_product_ids[${i}][id]`, menu?.id);
        formData.append(`pos_product_ids[${i}][amount]`, menu?.amount);
    });
    formData.append("reservation_id", reservationId);
    formData.append("name", name);
    formData.append("car_number", carNumber);
    formData.append("phone", phone);

    const {
      data: { success, alert, data: data2 },
    } = await api.post("/order", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    if (success) {
      handleClose()
      if (data2?.payment_price === 0) {
        window.paymentPopup(true, "")
      } else {
        if (data2?.payment_price >= 50000) {
          setSignModal({
            onDone: () => {
              window.rayno.payment(localStorage.getItem("token"), data2?.id, localStorage.getItem('installment'), "");
              localStorage.removeItem('installment')
              //localStorage.removeItem('signUrl')
            },
          });
        } else {
          window.rayno.payment(localStorage.getItem("token"), data2?.id, "00", "")
        }
      }
    } else {
      window.alert(alert);
    }
  };

  if (modal === null) return null;

  return (
    <ModalWrapper onClose={handleClose}>
      <Wrapper>
        {page === 1 && (
            <>
              <Title>결제자 정보 입력</Title>
              <PasswordArea>
                <Input
                    style={{ background: "#464650" }}
                    placeholder="차량번호 입력"
                    value={carNumber}
                    onChange={(e) => setCarNumber(e.target.value)}
                />
                <Input
                    style={{ background: "#464650" }}
                    placeholder="고객 성함"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                />
                <Input
                    style={{ background: "#464650" }}
                    placeholder="연락처"
                    value={phone}
                    onChange={(e) => setPhone(e.target.value)}
                />
              </PasswordArea>
            </>
        )}
        {page === 2 && (
            <>
              <Title>예약 선택</Title>
              <ReservationArea>
                {originalReservationData && originalReservationData.length > 0 ?
                    originalReservationData?.map((data, key) => (
                        <>
                          <ReservationItem className={reservationId === data?.id ? "select" : ""} onClick={() => setReservationId(data?.id)}>
                            <div style={{display: "flex", flexDirection: "column", justifyContent: "space-between", height: "auto", minHeight: "60px", padding: "5px"}}>
                              <p style={{color: "#ffffff"}}>
                                {data?.product_name ? data?.product_name : "-"}
                              </p>
                              <p style={{color: "#ffffff", fontSize: 12, fontWeight: 500, marginTop: "5px"}}>
                                예약일시: {data?.date ? data?.date + " " + (data?.time ? data?.time : "") : "-"}
                              </p>
                              <p style={{color: "#ffffff", fontSize: 12, fontWeight: 500}}>
                                등록일시: {data?.created_at ? moment(data?.created_at).format("YYYY-MM-DD HH:mm") : "-"}
                              </p>
                            </div>
                          </ReservationItem>
                        </>
                    ))

                    :

                    <>
                      <div style={{
                        display: "flex",
                        flexDirection: "column",
                        textAlign: "center",
                        alignItems: "center",
                        justifyContent: "center",
                        height: "200px",
                        color: "#FFFFFF",
                        lineHeight: "25px"
                      }}>
                        <NonSearch style={{marginBottom: "20px"}}/>
                        <div>
                          예약 정보가 존재하지 않습니다<br/>
                          다음 버튼을 누르실경우<br/> 워크인 고객으로 결제가 진행됩니다
                        </div>

                      </div>
                    </>
                }
              </ReservationArea>
            </>
        )}
        <div>
          <Button style={{ width: "43%", margin: "15px 10px 0 10px" }} styleType="line" onClick={handleClose}>
            취소
          </Button>
          <Button style={{ width: "43%", margin: "15px 10px 0 0", background: "#FFFFFFE5", color: "#0B0B0C" }} styleType="line" onClick={() => handlePage()}>
            다음
          </Button>
        </div>
      </Wrapper>
    </ModalWrapper>
  );
};

export default PaymentModal;

const ReservationArea = styled.div`
  display: flex;
  max-height: 300px;
  min-height: 200px;
  overflow-y: auto;
  flex-direction: column;
`

const ReservationItem = styled.div`
  background: ${(props) => props.theme.color.gray4};
  margin-bottom: 5px;
  border-radius: 10px;
  padding: 10px;
  flex-direction: column;
  justify-content: center;
  height: auto;
  
  &.select {
    background: rgb(48, 190, 142);
  }
`

const PasswordArea = styled.div`
  width: 220px;
  margin: auto;
  margin-bottom: 20px;

  & > label:nth-of-type(n + 2) {
    display: block;
    margin-top: 12px;
  }
`;

const Price = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 30px;

  font-size: 10px;
  font-weight: 500;
  line-height: 15px;
  letter-spacing: -0.01em;
  color: rgba(255, 255, 255, 0.6);

  & > p {
    font-size: 13px;
    font-weight: 500;
    line-height: 19.5px;
    color: white;

    & > span {
      font-size: 10px;
      line-height: 15px;
      margin-left: 2px;
    }
  }
`;

const Seperate = styled.div`
  margin: 30px 0 16px;
  width: 100%;
  height: 1px;
  background: ${(props) => props.theme.color.line};
`;

const TypeBox = styled.div`
  width: calc(50% - 5px);
  border-radius: 14px;
  border: solid 1px ${(props) => props.theme.color.gray4};
  padding: 25px 10px 18px;

  & > svg {
    width: 30px;
    height: 30px;
    margin: 0 auto 14px;
    display: block;
  }

  & > p {
    font-size: 13px;
    font-weight: 600;
    line-height: 13px;
    text-align: center;
    color: rgba(255, 255, 255, 0.9);
  }
`;

const TypeArea = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const Title = styled.div`
  font-size: 14px;
  font-weight: 700;
  line-height: 21px;
  color: white;
  margin-bottom: 18px;
`;

const Wrapper = styled.div`
  min-width: 284px;
  width: 284px;
  padding: 22px;
  background: ${(props) => props.theme.color.gray3};
  border-radius: 18px;
  border: solid 1px ${(props) => props.theme.color.gray4};
`;
